import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import 'tailwindcss/tailwind.css';
import '@sys/ui/styles/variables.css';
import '@sys/ui/styles/reset.css';
import './styles/theme.css';
import './styles/antd-reset.css';
import './styles/admin-page.css';

import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { i18n } from './locales';
import { permission, permissionAll, auth } from './directives/permission';
import { initTheme } from '@sys/shared/composables';
import { THEME_KEY } from '@sys/shared/constants';
import { cache } from '@sys/shared/utils';
import { applyGlobalScale } from './composables/useGlobalScale';
import { useLocaleStore } from '@/store/modules/locale';

const app = createApp(App);

app.use(Antd);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(router);
app.use(i18n);

// brand-admin 默认使用浅色后台主题；保留用户已经选择过的配色方案。
if (!cache.has(THEME_KEY)) {
  cache.set(THEME_KEY, 'soft-blue');
}

// 初始化主题（在挂载前执行，避免闪烁）
initTheme();

// 全局注册 $t 方法
app.config.globalProperties.$t = i18n.global.t;

// 注册权限指令
app.directive('permission', permission);
app.directive('permission-all', permissionAll);
app.directive('auth', auth);

// 全局缩放 — 小屏幕笔记本适配
applyGlobalScale();

// 提前拉取语言列表，避免组件首次渲染时看到静态 fallback（4 种语言）
const localeStore = useLocaleStore();
localeStore.init();

app.mount('#app');
